import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { languagesService } from 'src/services/languages.service'
import { IGetTranslationHelperTextStatusDto } from 'src/types'

export const useGetTranslationHelperTextStatus = (params: IGetTranslationHelperTextStatusDto) => {
  return useQuery(
    [QUERY_KEYS.TRANSLATION_HELPER_TEXT_STATUS, [params]],
    async () => languagesService.getTranslationHelperTextStatus(params),
    {
      keepPreviousData: false,

      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  )
}
